<template>
<div id="gnb_wrap" style="display:block">
	<div class="gnb-top-logo"><a :href="$cp">스마트은평 플랫폼</a></div>
	<!-- gnb -->
	<ul id="gnb">
		<li class="depth1">
			<a :href="$cp + 'realtime'">실시간 도시현황</a>
		</li>
		<li class="depth1">
			<a :href="$cp + 'biz'">변화의 은평</a>
		</li>
		<li class="depth1">
			<a :href="$cp + 'finance'">재정현황</a>
		</li>
		<li class="depth1">
			<a :href="$cp + 'indicator'">구정현황</a>
		</li>
		<li class="depth1">
			<a href="#gnb">은평생활</a>
			<ul class="depth2">
				<li><a :href="$cp + 'lifemap'">생활지도</a></li>
				<li><a :href="$cp + 'healing'">힐링은평</a></li>
                <li><a :href="$cp + 'waste'">생활폐기물</a></li>
                <li><a :href="$cp + 'commercial'">상권분석</a></li>
			</ul>
		</li>
		<li class="depth1">
			<a :href="$cp + 'opinion'">여론동향</a>
		</li>
	</ul>
	<!-- //gnb -->
	<a class="gnb-close" @click="closeNav" style="cursor: pointer;">닫기</a>
</div>
</template>

<script>
import commonConstMixin from "@/store/common.const.mixin.js"


export default {
	name: 'GNB',
    methods: {
		closeNav() {
			document.getElementById("gnb_wrap").style.height = "0%";
		}
	},
	mixins: [commonConstMixin],
}
</script>
